import ReactDOM from "react-dom/client";
import React from "react";
import ProductListPageTypeConfig from "../ProductListPageTypeConfig";
import { Currency } from "../../../../js/common/CurrencyFormatter";
import ProductListFilter from "./ProductListFilter";
import ProductListFiltersModal from "./ProductListFiltersModal";
import { FilterSourceData } from "./FilterValuesCollection";

export default new class ProductListFiltersModalService {
    private pageTypeConfig: ProductListPageTypeConfig | undefined;
    private filterData: FilterSourceData | undefined;
    private filter: ProductListFilter | undefined;
    private currency: Currency | undefined;

    public init(pageTypeConfig: ProductListPageTypeConfig, currency: Currency, filter: ProductListFilter, filterData?: FilterSourceData): void {
        this.pageTypeConfig = pageTypeConfig;
        this.filter = filter;
        this.currency = currency;

        if (filterData !== undefined) {
            this.filterData = filterData;
        }

        for (const openFilterButton of document.querySelectorAll<HTMLButtonElement>(".js-open-filter-products-button")) {
            openFilterButton.removeEventListener("click", this.clickEventHandler);
            openFilterButton.addEventListener("click", this.clickEventHandler);
        }
    }

    public setFilterData(filterData: FilterSourceData): void {
        this.filterData = filterData;
    }

    private readonly clickEventHandler = (event: MouseEvent): void => {
        event.preventDefault();
        this.openFilterModal();
    };

    private openFilterModal(): void {
        if (this.pageTypeConfig === undefined || this.filter === undefined || this.currency === undefined || this.filterData === undefined) {
            throw new Error("Filter data not defined.");
        }

        const containerElement = document.createElement("div");
        const reactRoot = ReactDOM.createRoot(containerElement);

        reactRoot.render(<ProductListFiltersModal
            pageTypeConfig={this.pageTypeConfig}
            filterData={this.filterData}
            currency={this.currency}
            initialFilter={this.filter.getFilterValues()}
            onAfterClose={(): void => {
                reactRoot.unmount();
                containerElement.remove();
            }}
        />);
    }
}();
